
import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue 
} from '../../components/ui/select';
import { 
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Calendar as CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';

interface TeacherSalaryInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const TeacherSalaryInfo = ({ formData, handleChange }: TeacherSalaryInfoProps) => {
  const handleJoinDateChange = (date: Date | undefined) => {
    if (date) {
      handleChange({
        target: { name: 'joinDate', value: date.toISOString() }
      } as any);
    }
  };

  const handleContractEndDateChange = (date: Date | undefined) => {
    if (date) {
      handleChange({
        target: { name: 'contractEndDate', value: date.toISOString() }
      } as any);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="joinDate">Join Date</Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="w-full justify-start text-left font-normal"
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {formData.joinDate ? (
                format(new Date(formData.joinDate), 'PPP')
              ) : (
                <span>Pick a date</span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={formData.joinDate ? new Date(formData.joinDate) : undefined}
              onSelect={handleJoinDateChange}
              disabled={(date) => date > new Date()}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="contractEndDate">Contract End Date</Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button
              variant="outline"
              className="w-full justify-start text-left font-normal"
            >
              <CalendarIcon className="mr-2 h-4 w-4" />
              {formData.contractEndDate ? (
                format(new Date(formData.contractEndDate), 'PPP')
              ) : (
                <span>Pick a date</span>
              )}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0" align="start">
            <Calendar
              mode="single"
              selected={formData.contractEndDate ? new Date(formData.contractEndDate) : undefined}
              onSelect={handleContractEndDateChange}
              disabled={(date) => date < new Date()}
              initialFocus
            />
          </PopoverContent>
        </Popover>
      </div>

      <div className="space-y-2">
        <Label htmlFor="salary">Salary (AFN)</Label>
        <div className="relative">
          <Input
            id="salary"
            name="salary"
            placeholder="Enter salary amount"
            value={formData.salary || ''}
            onChange={handleChange}
            className="pl-10"
            inputMode="numeric"
            type="text"
          />
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
            AFN
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="paymentStatus">Payment Status</Label>
        <Select name="paymentStatus" value={formData.paymentStatus || ''} onValueChange={(value) => {
          handleChange({
            target: { name: 'paymentStatus', value }
          } as any);
        }}>
          <SelectTrigger>
            <SelectValue placeholder="Select payment status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="paid">Paid</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="partial">Partial</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default TeacherSalaryInfo;
